import { GlobalProperties } from "src/app/global/global-properties";

export class WrapperStandardRequest<T> {
    UserId: string;
    UserGuid: string| null;
    CompanyCode: string;
    FolderName:string;
    RequestData: T | undefined;
    PageRecordCount: number;
    PageSize: number;
    IsAcending: boolean;
    SortColumn: string;
    CompanyGuid:string|null; 
    UseSap:boolean;

    constructor() {
        
        let userGuid = sessionStorage.getItem('UserGuid');
        this.UserGuid = userGuid && userGuid.trim() !== "" 
        ? userGuid 
        : "418DCDA6-7E91-43AF-AEF5-7F2BE4A9ECF1";
        this.UserId = "0";
        this.CompanyCode = GlobalProperties._compnayCode;
        this.FolderName=GlobalProperties._folderName
        this.PageRecordCount = 10;
        this.PageSize = 1;
        this.IsAcending = true;
        this.SortColumn = "";
        this.UseSap=true
        this.CompanyGuid=sessionStorage.getItem("companyGUID");
    }
};
export class WrapperStandardRequestCustom<T> {
    UserId: string;
    UserGuid: string| null;
    CompanyCode: string;
     FolderName:string;
    RequestData: T | undefined;
    PageRecordCount: number;
    PageSize: number;
    IsAcending: boolean;
    SortColumn: string;
    UseSap:boolean;
    CompanyGuid : string | null;
    constructor() {
         let userGuid=   sessionStorage.getItem('UserGuid');
    //    this.UserGuid = userGuid;
    this.UserGuid = userGuid && userGuid.trim() !== "" 
    ? userGuid 
    : "418DCDA6-7E91-43AF-AEF5-7F2BE4A9ECF1";

         this.FolderName=GlobalProperties._folderName
        this.UserId = "0";
         this.UseSap=true
        this.CompanyCode = GlobalProperties._compnayCode;
        // this.CompanyCode = "MSME1";
        
        this.PageRecordCount = 10;
        this.PageSize = 1;
        this.IsAcending = true;
        this.SortColumn = "";
        this.CompanyGuid = "";
    }
};

export class WrapperStandardResponse<T> {
    responseData: T | any;
    accessToken: string = "";
    currentPage!: number;
    pageRecordCount!:number;
    pageSize!:number;
    rowCount!: number;
};
export class WrapperStandardFilter {
    Key: string = "";
    Value: string |null | number= "";
    OperatorType: string|null = "";
}
export class WrapperStandardRoute {
    ObjType?:string = "";
    ObjKey?:string = "";
}
export class CommonFilterModel {
    value: string = '';
    description:  string = '';
}
export class CommonEnumData {
    
}